import {
    Routes,
    Route,
} from "react-router-dom";
import ChargeDisputesPage from "./charge-disputes-page.component";
import ChargeDisputeViewPage from "./charge-dispute-detailed-view.component";
import ResolveChargeDispute from "./resolve-dispute";



export default function ChargeDisputesRoutes() {
    return (
        <Routes>
            <Route path="/" element={<ChargeDisputesPage />} />
            <Route path="view/:id"  element={<ChargeDisputeViewPage load />}/>
            <Route path="/resolve/:id" element={<ResolveChargeDispute />} />
        </Routes>
    )
}